import type React from "react";

import { Route, Routes } from "react-router-dom";

import { useProfileContext } from "contexts/ProfileContext";
import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";
import { userIsAdmin, userIsBillingAdmin, userIsPartner } from "utils/profile/profileHelper";

import { ClinicPartnerAdminView } from "./partnerui/ClinicPartnerAdminView";
import { AdminView } from "./views";

export const AdminRoutes: React.FC = () => {
  const { profile } = useProfileContext();
  const offsetTop = usePageContentOffsetTop();
  const isPartnerOnly = userIsPartner(profile) && !userIsAdmin(profile) && !userIsBillingAdmin(profile);

  if (isPartnerOnly) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <Container $pageContentOffsetTop={offsetTop}>
              <ClinicPartnerAdminView />
            </Container>
          }
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Container $pageContentOffsetTop={offsetTop}>
            <AdminView />
          </Container>
        }
      />
    </Routes>
  );
};
